export default __webpack_public_path__ + "static/media/Integration Square.d3934225.jpg";